module.exports = __webpack_public_path__ + "85738fc90fde6832ba706c47200df5a8.png";